import FilesUpload from "components/EvtKit/file-upload/FilesUpload"
import IconCloudUpload from "components/EvtKit/icons/IconCloudUpload"
import IconImage from "components/EvtKit/icons/IconImage"
import BodyText from "components/Typography/BodyText"
import Caption from "components/Typography/Caption"
import React, { memo } from "react"
import styled from "styled-components"
import FileUploadButtonV2 from "components/EvtKit/file-upload/FileUploadButtonV2"

const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`

const ImageInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  height: 100%;
  border-radius: 16px;
  padding: 16px;
  border: 1px solid ${(props) => props.theme.palette.mediumGray};
  margin-top: 24px;
`

const StyledListItem = styled.li`
  margin-left: 16px;
  display: list-item;

  &::marker {
    font-size: 10px;
  }
`

const InstructionsList = styled.ul`
  color: ${(props) => props.theme.palette.secondary_medium};
  list-style-type: disc;
`

const SpanSemiBold = styled.span`
  font-weight: 600;
`

interface BannerImageInfoProps {
  handleBannerFileChange: (files: File[]) => void
}

const BannerImageInfo: React.FC<BannerImageInfoProps> = (props: BannerImageInfoProps) => {
  const { handleBannerFileChange } = props

  return (
    <ImageInfoContainer>
      <TitleContainer>
        <IconImage />
        <BodyText size="small" weight="semi-bold" color="secondary-medium">
          Imagem
        </BodyText>
      </TitleContainer>
      <Caption size="large" color="secondary-dark">
        Para subir uma imagem no banner do seu produto, siga estas instruções:
      </Caption>
      <InstructionsList>
        <StyledListItem>
          <Caption size="medium" color="secondary-dark">
            Escolha uma imagem que <SpanSemiBold>represente</SpanSemiBold> o seu produto.
          </Caption>
        </StyledListItem>
        <StyledListItem>
          <Caption size="medium" color="secondary-dark">
            Para elementos isolados, use um <SpanSemiBold> fundo transparente.</SpanSemiBold>
          </Caption>
        </StyledListItem>
        <StyledListItem>
          <Caption size="medium" color="secondary-dark">
            A imagem deve estar nos formatos <SpanSemiBold>.png ou .webp; </SpanSemiBold>
            dimensões<SpanSemiBold> 400x516px; </SpanSemiBold> tamanho máximo até 2MB
          </Caption>
          <Caption size="medium" color="secondary-dark">
            <SpanSemiBold>(A imagem ficará centralizada)</SpanSemiBold>
          </Caption>
        </StyledListItem>
      </InstructionsList>
      <FilesUpload acceptFormats={["image/png", "image/webp"]} onFilesChange={handleBannerFileChange}>
        <FileUploadButtonV2
          label={"Upload da imagem"}
          iconLeft={<IconCloudUpload />}
          className="fill-width secondary-medium height-small"
        >
          <Caption size="large" color="secondary-medium" weight="semi-bold">
            Upload da imagem
          </Caption>
        </FileUploadButtonV2>
      </FilesUpload>
    </ImageInfoContainer>
  )
}

export default memo(BannerImageInfo)
